import {
  AtsFileFragment,
  DeleteAtsFileDocument,
  DeleteAtsFileMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteAtsFile = (ats_file: AtsFileFragment) => {
  const [deleteAtsFileMutation, { loading }] = useMutation(DeleteAtsFileDocument, {
    extractorFn: (data: DeleteAtsFileMutation) => data.atsMutations.deleteAtsFile,
  })

  return {
    loading,
    deleteAtsFile() {
      return deleteAtsFileMutation({
        variables: { id: ats_file.id },
        update(cache) {
          cache.evict({ id: cache.identify(ats_file) })
        },
      })
    },
  }
}
